import React, { useState } from "react";
import locationMap from "assets/images/location_intelligence_map.png";
import { ReactComponent as NetworkWiredIcon } from "assets/icons/network_wired.svg";
import { ReactComponent as InfoIcon } from "assets/icons/info_2.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import useAuth from "hooks/useAuth";
import useProperties from "hooks/useProperties";
import useSubscription from "hooks/useSubscription";
const LocationIntelligence = ({ property }) => {
  const { toggleLocationItelligencePopup } = useProperties();

  const { user } = useAuth();
  const { subscriptionStatus } = useSubscription();
  const isPremium = subscriptionStatus.hasPremium;

  return (
    <div className="mt-4 lg:mt-[19px] xl:h-[316px] grid grid-rows-[auto,1fr] overflow-hidden">
      <div className="flex items-center bg-white z-[1] justify-between">
        <h2 className="text-[16px] md:text-[18px] lg:text-[22px] font-bold leading-[28px] text-black mb-[13px]">
          Location Intelligence
        </h2>
        {(!user || !isPremium) && (
          <>
            <span
              className="cursor-pointer"
              data-tooltip-id="not_subscribed_location_tooltip"
              data-tooltip-content="Utilizziamo l’intelligenza artificiale per mostrare informazioni sui servizi disponibili nelle vicinanze, e fornire una panoramica completa sulla logistica urbana degli spostamenti. Con l'iscrizione gratuita potrai visualizzare queste informazioni."
            >
              <InfoIcon />
            </span>
            {/* Info Tooltip  */}
            <ReactTooltip
              id="not_subscribed_location_tooltip"
              place="top"
              positionStrategy="fixed"
              className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
            />
          </>
        )}
      </div>
      <div
        className={` rounded-[20px] relative bg-white w-full h-full overflow-hidden`}
      >
        {(!user || !isPremium) && (
          <div className="backdrop-blur-[20px] absolute top-0 left-0 right-0 bottom-0 z-[1] rounded-[20px]" />
        )}
        <img
          src={locationMap}
          alt="map"
          className="w-full h-full rounded-[20px] object-cover"
        />
        <div
          onClick={() =>
            user && isPremium && toggleLocationItelligencePopup(property?._id)
          }
          className="absolute left-0 right-0 w-full bottom-[15px]"
        >
          <div className="flex items-center space-x-3 h-10 bg-[#F0F2F380] cursor-pointer mx-auto max-w-fit rounded-[8px] shadow-md min-w-fit px-[14px] ">
            <NetworkWiredIcon />
            <p className="text-[12px] text-black flex-shrink-0 font-semibold">
              Attiva la Location Intelligence
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationIntelligence;
